import { NumberObject } from '../types/number-object';

/**
 * Get a number from an object key-value pair object if defined
 * @param key key for value
 * @param object object to get value from
 * @returns  number
 */
export default function getNumberFromObjectKvp(
  key: string,
  object?: NumberObject
): number | undefined {
  return object && typeof object === 'object' && typeof object[key] === 'number'
    ? object[key]
    : undefined;
}
